/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  DefaultSettlementConfigurationService,
  type Wealthlane_AwardSettlementService_Dtos_DefaultSettlementConfiguration_DefaultSettlementConfigurationDto,
} from '@wealthlane/api-services/wealthlane-award-settlement-service';

const usePostSettlementConfig = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  | Wealthlane_AwardSettlementService_Dtos_DefaultSettlementConfiguration_DefaultSettlementConfigurationDto[]
  | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        DefaultSettlementConfigurationService.postApiAwardSettlementApiAppDefaultSettlementConfigurationSaveDefaultSettlementConfiguration(
          payload
        )
      );
    },
    {
      onSuccess: async (response) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message={'Configuration saved'} />);
          await queryClient.invalidateQueries('getDefaultSettlementConfigurationList');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostSettlementConfig;
